export const FlavourDescriptionBody = ({ bod }) => {
  return (
    <div className="description-section-two">
      Flavour Flames brings the vibrant flavours of Caribbean cuisine to the
      Midlands through its distinctive catering service, tailored to British,
      Asian, and Afro-Caribbean communities.
      <br />
      <br />
      Tasked with capturing the essence of Caribbean culture and identity, my
      challenge was to design the fundamental aspects of a visual brand that
      resonates with diverse communities while embodying the richness of
      Caribbean cuisine. From logo design to colour palette selection, every
      element aimed to evoke the warmth and vibrancy of Caribbean flavours,
      ensuring a striking and memorable brand presence.
      <br />
      <br />
      With simplicity as my guiding principle, I sought to create a visual brand
      identity that serves as the face of Flavour Flames. The logo design and
      colour choices are designed to reflect the authenticity and accessibility
      of Caribbean cuisine, inviting customers to experience the taste of the
      islands.
    </div>
  );
};
